import * as React from "react";
import { connect } from "react-redux";

import { isEqual } from "lodash";
import { Grid, Table, InputOnChangeData, Button, Form } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";

import { PartiallyMatchedEmployeeListModel } from "../model";
import { partiallyMatchedEmployeesSelector, SelectorState as PartiallyMatchedEmployeesSelectorState } from "../common/selectors";
import { TeamListModel, loadTeams } from "../../teams";
import { teamsSelector } from "../../teams/selectors";
import { ApplicationState } from "../../applicationState";

import { loadPartiallyMatchedEmployees } from "../common/actions";

import { Link, replace } from "redux-little-router";

interface AllProps {
    partiallyMatchedEmployees: PartiallyMatchedEmployeeListModel[];
    path: string;
    teams: TeamListModel[];
}

interface AllDispatchProps {
    onFilterValueChange: (teamIds: string[]) => void;
    loadTeams: () => Promise<void>;
    loadPartiallyMatchedEmployees: () => void;
}

interface AllState {
    firstName: string;
    selectedTeams: TeamListModel[];
    selectedTeamIds: string[];
}

export class AllUnconnected extends React.Component<AllProps & AllDispatchProps, AllState> {
    constructor(props: AllProps & AllDispatchProps) {
        super(props);
        this.state = {
            firstName: "",
            selectedTeams: [],
            selectedTeamIds: []
        };
        this.onFilterValueChange = this.onFilterValueChange.bind(this);
        this.onTeamsChanged = this.onTeamsChanged.bind(this);

        if (!props.teams?.length) {
            props.loadTeams();
        }

        props.loadPartiallyMatchedEmployees();
    }

    public render() {
        return (
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column width={14}>
                        <h1>Partially-Matched Employees</h1>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Form>
                            <Grid columns="2">
                                <Grid.Column>
                                    <Input.DropdownMulti
                                        dynamicOptions
                                        label="Teams"
                                        options={this.props.teams.map(team => ({ key: team.id, value: team.id, text: team.name }))}
                                        onChange={this.onTeamsChanged}
                                        value={this.state.selectedTeams.map(team => team.id)}
                                        search
                                    />
                                </Grid.Column>
                                <Grid.Column />
                            </Grid>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Customer Name</Table.HeaderCell>
                                    <Table.HeaderCell>Employee Name</Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.props.partiallyMatchedEmployees.map(partiallyMatchedEmployee => (
                                    <Table.Row key={partiallyMatchedEmployee.id}>
                                        <Table.Cell>
                                            {partiallyMatchedEmployee.customerName}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {partiallyMatchedEmployee.referredName}
                                        </Table.Cell>
                                        <Table.Cell>
                                            { /* eslint-disable-next-line max-len */}
                                            <Link href={`${this.props.path}/${partiallyMatchedEmployee.formType}/${partiallyMatchedEmployee.customerId}/${partiallyMatchedEmployee.id}`}>
                                                <Button content="View" />
                                            </Link>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
    private onFilterValueChange(event: any, { value }: InputOnChangeData) {
        this.setState({ firstName: value });
    }
    private onTeamsChanged(teamIds: string[]) {
        const selectedTeams = teamIds.map(teamId => this.props.teams.find(team => team.id === teamId)!);
        if (!isEqual(selectedTeams, this.state.selectedTeams)) {
            this.setState({ selectedTeams, selectedTeamIds: teamIds });
            this.props.onFilterValueChange(teamIds);
        }
    }
}

function mapStateToProps(state: PartiallyMatchedEmployeesSelectorState & ApplicationState): AllProps {
    return {
        path: state.router.pathname!,
        partiallyMatchedEmployees: partiallyMatchedEmployeesSelector((state)).sort((a, b) => a.referredName!.localeCompare(b.referredName!)),
        teams: teamsSelector(state)
    };
}

function mapDispatchToProps(dispatch: any): AllDispatchProps {
    return {
        onFilterValueChange: (teamIds: string[]) => {
            const params: string[] = [];
            teamIds.forEach(teamId => {
                params.push(`teamIds=${teamId}`);
            });
            const paramsString = params.join("&");

            dispatch(replace(`partiallyMatchedEmployees?${paramsString}`));
        },
        loadTeams: () => dispatch(loadTeams()),
        loadPartiallyMatchedEmployees: () => dispatch(loadPartiallyMatchedEmployees())
    };
}

export const All = connect(mapStateToProps, mapDispatchToProps)(AllUnconnected);
